module.exports = __webpack_public_path__ + "media/images/accountSection__profileImage--dark-0f8b4cd702bbab7b239ec082b66fe97c.png";